<template>
  <section>
    <div v-if="loading">
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center mb-4">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
          <app-icon
            v-bind:name="'search'"
            v-bind:classname="'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'"
          ></app-icon>
          <input
            type="text"
            class="input w-full sm:w-64 box px-10 text-gray-700"
            placeholder="Buscar por nombre"
            v-model="filter.name"
          />
          <div
            class="inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
          >
            <app-icon
              v-bind:name="'chevron-down'"
              v-bind:classname="'dropdown-toggle w-4 h-4 cursor-pointer text-gray-700'"
            ></app-icon>
            <div
              class="inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
            >
              <div class="dropdown-box__content box p-5">
                <div class="grid grid-cols-12 gap-4 row-gap-3">
                  <div class="col-span-6">
                    <div class="text-xs">Grupo</div>
                    <select
                      class="input w-full border mt-2 flex-1"
                      v-model="filter.group"
                      required
                    >
                      <option disabled selected>Seleccione la cuenta</option>
                      <option
                        v-for="group in groups"
                        v-bind:key="group.id"
                        v-bind:value="group.id"
                      >
                        {{ group.name }}
                      </option>
                      <option value="">Todos</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full sm:w-auto flex">
          <a
            data-target="#account"
            data-toggle="modal"
            class="button text-white bg-theme-1 shadow-md mr-2"
            >Crear Cuenta</a
          >
        </div>
      </div>
      <!-- END: Filter -->

      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="boxedit">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">Editar Cuenta</h2>
        </div>
        <form @submit.prevent="updateAccount">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-6 sm:col-span-6">
              <label>Nombre:</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="account_current.name"
                required
              />
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Prefijo:</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="account_current.prefix"
                required
              />
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>País</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="account_current.country_id"
                required
              >
                <option seleted value="">Seleccione el país</option>
                <option v-for="country in countries" :value="country.id">
                  {{ country.name }}
                </option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Grupo</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="account_current.account_group_id"
                required
              >
                <option seleted :value="null">Seleccione el grupo</option>
                <option v-for="group in groups" :value="group.id">
                  {{ group.name }}
                </option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Razon Social</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="account_current.social_reason_id"
                required
                :disabled="!account_current.country_id"
              >
                <option seleted :value="null">
                  Seleccione la Razon Social
                </option>
                <option
                  v-for="socialreason in socialreasonsfiltered"
                  :value="socialreason.id"
                >
                  {{ socialreason.name }}
                </option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Estado</label>
              <select
                class="input w-full border mt-2"
                v-model="account_current.status"
                required
              >
                <option disabled>Seleccione el usuario</option>
                <option value="0">Inactivo</option>
                <option value="1">Activo</option>
              </select>
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button
              type="button"
              @click="closeEditAccount()"
              class="button w-20 border text-gray-700 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="button w-20 bg-theme-1 text-white"
              id="create"
            >
              Modificar
            </button>
          </div>
        </form>
      </div>
      <!-- END: Edit -->

      <!-- List -->
      <h2 class="mb-2 text-lg font-bold">
          Cuentas ({{ accounts.length }})
      </h2>
      <div class="intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5">
        <div
          class="intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-2"
          v-for="account in filteredAccounts"
        >
          <div
            class="file box rounded-md px-5 pt-8 pb-5 px-3 sm:px-5 relative zoom-in"
          >
            <a href="#" class="w-3/5 file__icon file__icon--directory mx-auto">
              <div class="file__icon__file-name"></div>
            </a>
            <a href="#" class="block font-medium mt-4 text-center truncate text-xs text-gray-500"
              >{{ account.group.name }}</a>
            <a href="#" class="block font-medium mt-1 text-center truncate"
              >{{ account.name }} - {{ account.country.prefix }}</a
            >
            <div class="text-gray-600 text-xs text-center">
              {{ account.status === 0 ? 'Inactivo' : 'Activo' }}
            </div>
            <div class="absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto">
              <a class="dropdown-toggle w-5 h-5 block" href="javascript:;">
                <app-icon
                  :name="'more-vertical'"
                  :classname="'w-5 h-5 text-gray-500'"
                ></app-icon>
              </a>
              <div class="dropdown-box mt-5 absolute w-40 top-0 right-0 z-10">
                <div class="dropdown-box__content box p-2">
                  <a
                    @click="editAccount(account)"
                    class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <app-icon
                      :name="'edit'"
                      :classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Editar
                  </a>
                  <a
                    @click="removeAccount(account)"
                    class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <app-icon
                      :name="'trash'"
                      :classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Eliminar
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END: List -->
    </div>

    <div v-else>
      <app-loading></app-loading>
    </div>

    <!-- Modal -->
    <div class="modal" id="account">
      <div class="modal__content modal__content--md">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">Crear Cuenta</h2>
        </div>
        <form @submit.prevent="createAccount">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-12">
              <label>Nombre:</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                placeholder="Mayusculas"
                v-model="account.name"
                required
              />
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Prefijo:</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                placeholder="5 Letras"
                v-model="account.prefix"
                required
              />
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>País</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="account.country_id"
                required
              >
                <option seleted value="">Seleccione el país</option>
                <option v-for="country in countries" :value="country.id">
                  {{ country.name }}
                </option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Grupo</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="account.account_group_id"
                required
              >
                <option seleted :value="null">Seleccione el grupo</option>
                <option v-for="group in groups" :value="group.id">
                  {{ group.name }}
                </option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-6">
              <label>Razon Social</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="account.social_reason_id"
                required
                :disabled="!account.country_id"
              >
                <option seleted :value="null">
                  Seleccione la Razon Social
                </option>
                <option
                  v-for="socialreason in socialreasonsfiltered"
                  :value="socialreason.id"
                >
                  {{ socialreason.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 border text-gray-700 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="button w-20 bg-theme-1 text-white"
              id="create"
            >
              Crear
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal End -->
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminListAccount',
  data() {
    return {
      loading: false,
      boxedit: false,
      account: this.defineAccount(),
      account_current: {},
      accounts_active: 0,
      groups: null,
      filter: {
        name: '',
        group: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      accounts: 'getAccounts',
      countries: 'getAccountCountries',
      socialreasons: 'getSocialReasons',
    }),
    socialreasonsfiltered() {
      return this.socialreasons.filter((socialreason) => {
        if (
          socialreason.country_id == this.account.country_id ||
          socialreason.country_id == this.account_current.country_id
        ) {
          return socialreason
        }
      })
    },
    countAccountsActive() {
      let count = 0
      this.accounts.filter((item) => {
        if (item.status == 1) {
          count++
        }
      })

      this.accounts_active = count
      return count
    },
    filteredAccounts: function () {
      return this.accounts.filter((item) => {
        let name = this.filter.name ? item.name.toLowerCase()
            .includes(this.filter.name.toLowerCase()) : true
        let account_group_id = this.filter.group
          ? item.account_group_id === this.filter.group
          : true
        
        return name && account_group_id
      })
    },
  },
  beforeMount() {
    //SEND ENTITY AND MUTATION
    this.getAll('account').then(() => {
      this.loading = true
    }),
    this.getList('socialreason').then(() => {
      this.loading = true
    }),
    this.getList('accountcountry').then(() => {
      this.loading = true
    })
      this.getGroups()
  },
  methods: {
    async getGroups() {
      this.loading = false
      try {
        const { list } = await this.get(`/account-group`)
        this.groups = list
        this.loading = true
      } catch (error) {
        console.log(error)
        this.loading = true
      } finally {
        this.loading = true
      }
    },
    defineAccount() {
      return {
        name: '',
        prefix: '',
        country_id: '',
        status: '',
        entity: 'account',
        social_reason_id: null,
        account_group_id: null
      }
    },
    createAccount() {
      var vm = this
      window.$('#create').button('loading')
      vm.account.status = 1
      vm.store(vm.account)
        .then((item) => {
          window.$('#account').modal('hide')
          this.defineAccount()
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/traffic/accounts'
          )
        })
        .catch((error) => {
          window.$('#create').button('reset')
          this.defineAccount()
        })
    },
    removeAccount: function (value) {
      var vm = this
      vm.form = {
        id: value.id,
        entity: 'account',
      }
      vm.loading = false
      vm.remove(vm.form)
        .then((item) => {
          vm.loading = true
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/traffic/accounts'
          )
        })
        .catch((message) => {
          vm.loading = true
        })
    },
    editAccount: function (value) {
      this.boxedit = true
      this.account_current = JSON.parse(JSON.stringify(value))
    },
    closeEditAccount: function () {
      this.boxedit = false
      this.account_current = {}
    },
    updateAccount: function (value) {
      var vm = this
      vm.account_current.entity = 'account'
      vm.loading = false
      vm.update(vm.account_current)
        .then((item) => {
          vm.loading = true
          vm.boxedit = false
          vm.account = { name: '', entity: 'account' }
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/traffic/accounts'
          )
        })
        .catch((message) => {
          vm.loading = true
        })
    },
    ...mapActions(['get', 'getAll', 'getList', 'remove', 'store', 'update']),
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
  },
}
</script>



// WEBPACK FOOTER //
// ListAccount.vue?06e4b0ef